import axios from "axios";
import { createContext, useContext, useState } from "react"
import { useNavigate } from "react-router-dom";
import { BASE_API } from "../../../constants/api";
import { errorNotify } from "../../../shared/notifications";
import { persianLanguage } from "../../../constants/persianTerms";
const AuthContext = createContext();

const AuthProvider = ({children}) => {
    const loginUrlApi = `${BASE_API}token/`;
    const otpValidationApiUrl = `${BASE_API}otp/validation/`

    const [user, setUser] = useState(JSON.parse(localStorage.getItem('user')) || null);
    const [token, setToken] = useState(localStorage.getItem('token') || '' );
    const navigate = useNavigate();

    const loginAction = (data) => {
        axios.post(loginUrlApi, data).then(
            (response) => {
                const user = {
                    'id': response.data.id,
                    'fullName': response.data.fullName,
                    'userType': response.data.userType,
                    'expiresIn': response.data.expiresIn,
                    'isAdmin': response.data.isAdmin,
                };
                setUser(user);
                setToken(response.data.access);
                localStorage.setItem('token', response.data.access)
                localStorage.setItem('user', JSON.stringify(user))
                navigate("/");
            }
        ).catch(
            (error) => {
                if(error.response){
                    if(error.response.status === 400){
                        errorNotify(persianLanguage.phrase.error.ERROR_400);
                    } else if(error.response.status === 401){
                        errorNotify(persianLanguage.phrase.error.ERROR_401);
                    } else if(error.response.status === 403){
                        errorNotify(persianLanguage.phrase.error.ERROR_403);
                    }else if(error.response.status === 404){
                        errorNotify(persianLanguage.phrase.error.ERROR_404);
                    }
                }

            }
        );
    }

    const otpLoginAction = async (data) => {
        return axios.post(otpValidationApiUrl, data).then(
            (response) => {
                const user = {
                    'id': response.data.id,
                    'fullName': response.data.fullName,
                    'firstName': response.data.firstName,
                    'lastName': response.data.lastName,
                    'hasName': response.data.hasName,
                    'userType': response.data.userType,
                    'expiresIn': response.data.expiresIn,
                    'profileId': response.data.profileId,
                    'isAdmin': response.data.isAdmin,
                };
                navigate("/");
                setUser(user);
                setToken(response.data.access);
                localStorage.setItem('token', response.data.access)
                localStorage.setItem('user', JSON.stringify(user));
                return response;
            }
        ).catch(
            (error) => {
                return Promise.reject(error); // ✅ return rejection properly
            }
        );
    }

    const logout = () => {
        navigate("/login/");
        setUser(null);
        setToken("");
        localStorage.removeItem("profilePopupDismissed");
        localStorage.removeItem('user');
        localStorage.removeItem('token');
    }

    return (
        <>
            <AuthContext.Provider 
            value={{user, 
            loginAction, 
            token, 
            logout,
            otpLoginAction }}>{children}</AuthContext.Provider>
        </>
    ) ;
};

export default AuthProvider;

export const useAuth = () => {
    return useContext(AuthContext);
};